var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgRankingNum1 = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 62"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.652 1.452A2.237 2.237 0 0 1 17.66 1.2h6.72c.56 0 .84.28.84.84v57.12c0 .56-.28.84-.84.84h-6.384c-.56 0-.84-.28-.84-.84V10.02c0-.112-.056-.196-.168-.252-.056-.112-.112-.14-.168-.084l-7.476 1.932-.336.084c-.336 0-.56-.252-.672-.756L8 6.24c0-.504.196-.84.588-1.008l8.064-3.78Z"
  })));
});
SvgRankingNum1.displayName = "SvgRankingNum1";
export default SvgRankingNum1;